/**
 * @graphql agg
 */
import { graphql } from 'react-relay';

export const ConfluenceFreePoolTargetExperimentGUPSQuery = graphql`
	query ConfluenceFreePoolTargetExperimentGUPSQuery($cloudId: ID!, $productKey: String!) {
		tenantContexts(cloudIds: [$cloudId]) {
			entitlementInfo(hamsProductKey: $productKey) {
				entitlement {
					entitlementProfile {
						paidFeatureUsage {
							featureName
						}
						trialHistory {
							trialType
						}
					}
				}
			}
		}
	}
`;
